function isStyledComponent(target) {
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

export { isStyledComponent as default };
